import { render, staticRenderFns } from "./ProductsCategoryComponent.html?vue&type=template&id=410af10f&"
import script from "./ProductsCategoryComponent.js?vue&type=script&lang=js&"
export * from "./ProductsCategoryComponent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports